import type { IconData } from '@stacksjs/iconify-core'

export const pin: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m477.8 140.2l-106-106a62.132 62.132 0 0 0-93.617 81.24l-4.913 5.533l-97.654 42.9l-42.611-23.026a24.04 24.04 0 0 0-28.86 4.638L62.6 189.487a23.88 23.88 0 0 0 .479 33.449l101.68 101.679L16 473.373V496h22.627l148.758-148.758L288.6 448.457a23.93 23.93 0 0 0 33.275.642l44.425-41.128a23.98 23.98 0 0 0 4.773-29.092l-23.344-42.858l42.131-90.515l8.6-10.318A62.134 62.134 0 0 0 477.8 140.2m-22.628 65.231a30.125 30.125 0 0 1-42.6 0l-16.885-16.886l-33.08 39.678l-50.7 108.933l28.087 51.566l-34.209 31.669L91.2 205.806l32-33.89l50.969 27.543l118.386-52.008l29.177-32.863l-15.158-15.161a30.126 30.126 0 0 1 42.6-42.6l106 106a30.126 30.126 0 0 1 0 42.6Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pin
